import React, {ReactNode} from "react";
import UserInfoDashBoard from "./UserInfoDashBoard";
import VulnerabilityDashBoard from "./VulnerabilityDashBoard";
import VpnInfoDashBoard from "./VpnInfoDashBoard";
import {DashBoardInfo} from "./Model/Interfaces";
import TaskGetDashBoard, {TaskGetDashBoardResponse} from "../ws/Task/TaskGetDashBoard";
import {FilterState, GoToLinkWithFiltersAndOrder, LoadingView} from "@cuatroochenta/co-admin-react-library";
import './dashboard.scss';
import TaskGetMessages, {TaskGetMessagesResponse} from "../ws/Task/TaskGetMessages";
import DashBoardMessages from "./DashBoardMessages";


interface DashboardState {
    loadingDashboard: boolean,
    loadingMessages: boolean,
    dashboardData: null | DashBoardInfo,
    messages: string[],
}

export default class DashBoardScreen extends React.Component<{}> {

    public state: DashboardState = {
        loadingDashboard: false,
        loadingMessages: false,
        dashboardData: null,
        messages: [],
    }

    public componentDidMount() {
        this.setState({loadingDashboard: true, loadingMessages: true});
        new TaskGetDashBoard()
            .onSuccess((data: TaskGetDashBoardResponse) => this.setState({
                loadingDashboard: false,
                dashboardData: data
            }))
            .onFail(() => this.setState({loadingDashboard: false}))
            .execute();
        new TaskGetMessages()
            .onSuccess((data: TaskGetMessagesResponse) => this.setState({loadingMessages: false, messages: data}))
            .onFail(() => this.setState({loadingMessages: false}))
            .execute();
        document.getElementsByClassName("content")[0].classList.add("show-scrollbar");
    }

    public componentWillUnmount() {
        document.getElementsByClassName("content")[0].classList.remove("show-scrollbar");
    }

    public render(): ReactNode {
        const {
            loadingDashboard,
            loadingMessages,
            dashboardData,
            messages,
        } = this.state;
        const loading = loadingDashboard || loadingMessages;

        if (loading) {
            return <LoadingView loading={true}/>;
        }

        return (
            <div className="main-panel" id="dashboard-screen">
                <div className="content mt-4">
                    <DashBoardMessages messages={messages}/>
                    {dashboardData &&
                        <>
                            <UserInfoDashBoard
                                userDashBoardInfo={dashboardData.user}
                                translations={dashboardData.translations}
                                goToLink={
                                    (entity, orderBy, orderAsc) =>
                                        GoToLinkWithFiltersAndOrder(
                                            entity,
                                            {} as FilterState,
                                            orderBy,
                                            orderAsc
                                        )
                                }
                            />
                            <VulnerabilityDashBoard
                                vulnerabilities={dashboardData.vulnerability}
                                dataGraph={dashboardData.dataGraph}
                                translations={dashboardData.translations}
                                goToLink={
                                    (entity, orderBy, orderAsc) => {
                                        GoToLinkWithFiltersAndOrder(
                                            entity,
                                            {} as FilterState,
                                            orderBy,
                                            orderAsc
                                        )
                                    }
                                }
                            />
                        </>
                    }
                    {
                        dashboardData && dashboardData.vpn &&
                        <VpnInfoDashBoard
                            vpnInfo={dashboardData.vpn}
                            translations={dashboardData.translations}
                            goToLink={
                                (entity, orderBy, orderAsc) =>
                                    GoToLinkWithFiltersAndOrder(
                                        entity,
                                        {} as FilterState,
                                        orderBy,
                                        orderAsc
                                    )
                            }
                        />
                    }
                </div>
            </div>
        );
    }
}
